import type { Panel } from "."
import type { Point2d, Scale2d, Rectangle2d } from "../2d"

export type Projector = {
  distance: (d: number, zoom: number) => number
  point: (point: Point2d, zoom: number) => Point2d
  scale: (scale: Scale2d, zoom: number) => Scale2d
  rectangle: (box: Rectangle2d, zoom: number) => Rectangle2d
  panel: (panel: Panel, zoom: number) => Panel
}

export const studioToScreen: Projector = {
  distance: (d, zoom) => (zoom / 100) * d,
  point: ({ x, y }, zoom) => ({
    x: (zoom / 100) * x,
    y: (zoom / 100) * y,
  }),
  scale: ({ h, w }, zoom) => ({
    h: (zoom / 100) * h,
    w: (zoom / 100) * w,
  }),
  rectangle: ({ x, y, w, h, r }, zoom) => ({
    x: (zoom / 100) * x,
    y: (zoom / 100) * y,
    w: (zoom / 100) * w,
    h: (zoom / 100) * h,
    r,
  }),
  panel: (panel, zoom) => ({
    ...panel,
    ...studioToScreen.rectangle(panel, zoom),
    xSnap: panel.xSnap ? (zoom / 100) * panel.xSnap : null,
    ySnap: panel.ySnap ? (zoom / 100) * panel.ySnap : null,
  }),
}

export const screenToStudio: Projector = {
  distance: (d, zoom) => (100 / zoom) * d,
  point: ({ x, y }, zoom) => ({
    x: (100 / zoom) * x,
    y: (100 / zoom) * y,
  }),
  scale: ({ h, w }, zoom) => ({
    h: (100 / zoom) * h,
    w: (100 / zoom) * w,
  }),
  rectangle: ({ x, y, w, h, r }, zoom) => ({
    x: (100 / zoom) * x,
    y: (100 / zoom) * y,
    w: (100 / zoom) * w,
    h: (100 / zoom) * h,
    r,
  }),
  panel: (panel, zoom) => ({
    ...panel,
    ...screenToStudio.rectangle(panel, zoom),
    xSnap: panel.xSnap ? (100 / zoom) * panel.xSnap : null,
    ySnap: panel.ySnap ? (100 / zoom) * panel.ySnap : null,
  }),
}
